import { Routes } from '@angular/router';
import { ROUTE_NAMES } from '@constants';

import { CommunityProfileGuard } from 'src/app/core/guards/community-profile.guard';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const homeRoutes: Routes = [
  {
    path: 'home',
    title: 'WEB_HOME_AAA',
    canActivate: [CommunityProfileGuard],
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/home.component').then((m) => m.HomeComponent),
    data: { navigationRoute: ROUTE_NAMES.HOME },
  },
];
